<mat-table [dataSource]="dataList" matSort [matSortDisableClear]="true" (matSortChange)="onSortChanged($event)">


  <ng-container matColumnDef="image">
    <mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@Image">Image</mat-header-cell>
    <mat-cell *matCellDef="let row" data-label="Image" i18n-data-label="@@Image">
      <a href="{{row.progressImageUrl}}" target="_blank"><img [src]="row.progressImageUrl" loading="lazy"></a>
    </mat-cell>
  </ng-container>

  <!-- EndDateString Column -->
  <ng-container matColumnDef="endDateString">
    <mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@EndDate"> Date </mat-header-cell>
    <mat-cell *matCellDef="let row" data-label="End Date" i18n-data-label="@@EndDate">
      {{ row.endDateString }}
    </mat-cell>
  </ng-container>


  <!-- MealPlanCompliance Column -->
  <ng-container matColumnDef="mealPlanCompliance">
    <mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@MealPlanCompliance"> Meal Plan Compliance
    </mat-header-cell>
    <mat-cell *matCellDef="let row" data-label="Meal Plan Compliance" i18n-data-label="@@MealPlanCompliance">
      {{ row.mealPlanCompliance }} - {{ MEAL_PLAN_COMPILANCE[row.mealPlanCompliance] }}
    </mat-cell>
  </ng-container>

  <!-- EnergyLevel Column -->
  <ng-container matColumnDef="energyLevel">
    <mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@EnergyLevel"> Energy Level </mat-header-cell>
    <mat-cell *matCellDef="let row" data-label="Energy Level" i18n-data-label="@@EnergyLevel">
      {{ row.energyLevel }} - {{ ENERGY_LEVEL[row.energyLevel] }}
    </mat-cell>
  </ng-container>

  <!-- StressLevel Column -->
  <ng-container matColumnDef="stressLevel">
    <mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@StressLevel"> Stress Level </mat-header-cell>
    <mat-cell *matCellDef="let row" data-label="Stress Level" i18n-data-label="@@StressLevel">
      {{ row.stressLevel }} - {{ STRESS_LEVEL[row.stressLevel] }}
    </mat-cell>
  </ng-container>

  <!-- SleepQuality Column -->
  <ng-container matColumnDef="sleepQuality">
    <mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@SleepQuality"> Sleep Quality </mat-header-cell>
    <mat-cell *matCellDef="let row" data-label="Sleep Quality" i18n-data-label="@@SleepQuality">
      {{ row.sleepQuality }} - {{ SLEEP_QUALITY[row.sleepQuality] }}
    </mat-cell>
  </ng-container>

  <!-- Actions -->
  <ng-container matColumnDef="actions">
    <mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@Actions"> Actions </mat-header-cell>
    <mat-cell *matCellDef="let row" data-label="Actions" i18n-data-label="@@Actions">
      <button nbButton ghost shape="round" size="small" (click)="onEdit(row.guid)">
        <img src="/assets/icons/added_oultine_modify_pencil.svg" alt="edit" class="img-archive" width="24" height="24">
      </button>
    </mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
  <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
</mat-table>

<mat-paginator #paginator [length]="totalCount" [pageSize]="10" (page)="loadDataList(true)"
  [class.hidden]="totalCount === 0">
</mat-paginator>

<div *ngIf="totalCount === 0" class="text-center p-4 border">
  No data found
</div>
